import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import InfoUnavailable from '../../../../components/common/InfoUnavailable';
import { capitalizeFirstLetter } from '../../../../utils/textFormatUtils';

const TherapeuticAlternatives = forwardRef(function (
  { therapeuticAlternatives },
  ref,
) {
  return (
    <div
      ref={ref}
      className="mb-36 scroll-offset"
      id="therapeutic-alternatives-section"
    >
      <h4 className="accordion-header">Therapeutic Alternatives</h4>

      <div className="accordion-body">
        {therapeuticAlternatives?.Items?.length ? (
          <div>
            <div className="row">
              <div className="col-12 drug-info mb-0">
                <ul className="risk-list">
                  <li>
                    <span className="label f-16 font-semibold">
                      {therapeuticAlternatives.Items.length > 0 &&
                        therapeuticAlternatives.Items[0].SUB_GROUP_DESC}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <ul className="indicator">
              {therapeuticAlternatives.Items.map((alternative, index) => (
                <li key={`therapeutic-alternative-${index}`}>
                  {capitalizeFirstLetter(alternative.GENERIC_DRUG_NAME)}
                </li>
              ))}
            </ul>
          </div>
        ) : (
          <InfoUnavailable />
        )}
      </div>
    </div>
  );
});

// Prop validation
TherapeuticAlternatives.propTypes = {
  therapeuticAlternatives: PropTypes.shape({
    Items: PropTypes.arrayOf(
      PropTypes.shape({
        SUB_GROUP_DESC: PropTypes.string.isRequired,
        GENERIC_DRUG_NAME: PropTypes.string.isRequired,
      }),
    ).isRequired,
  }).isRequired,
};

TherapeuticAlternatives.displayName = 'TherapeuticAlternatives';
export default TherapeuticAlternatives;
